import usePermissions from "./usePermissions";
import useCurrentUser from "./useCurrentUser";

/**
 * Asset Management from the role's "assets" permission:
 * - canManageAssets: view (menu + screens)
 * - canModifyAssets: modify (register / edit / assign / return)
 * - companyWide: COMPANY scope (asset types, whole-company lists)
 * hasEmployeeRecord: account linked to an employee.
 */
const useAssetAccess = () => {
  const user = useCurrentUser();
  const { can, companyWide } = usePermissions();
  return {
    canManageAssets: can("assets"),
    canModifyAssets: can("assets", "modify"),
    companyWide: companyWide("assets"),
    hasEmployeeRecord: !!user.employeeId,
  };
};

export default useAssetAccess;
